import * as constants from 'redux/constants/favourite.constants';

export const updateFavourite = (itemId, favourite) => ({
  type: constants.FAVOURITE_UPDATE_REQUESTED,
  itemId,
  favourite,
});

export default { updateFavourite };
